import React, { createContext, useContext, useState, type ReactNode } from "react";
import { GroupType } from "../../domain/group/group-type";

interface ILoginAsContextType {
  loginAsTypes: GroupType[] | undefined;
  setLoginAsTypes(type: GroupType[] | undefined): void;
  setLoggedAs(loggedAs: boolean): void;
  loggedAs: boolean;
}

const LoginAsContext = createContext<ILoginAsContextType>({} as ILoginAsContextType);

interface ILoginAsProviderProps {
  children: ReactNode;
}

export const LoginAsProvider = (props: ILoginAsProviderProps) => {
  const value = useLoginAsProvider();
  return <LoginAsContext.Provider value={value}>{props.children}</LoginAsContext.Provider>;
};

export const useLoginAs = () => {
  return useContext(LoginAsContext);
};

const useLoginAsProvider = (): ILoginAsContextType => {
  const [loginAsTypes, setLoginAsTypes] = useState<GroupType[]>();
  const [loggedAs, setLoggedAs] = useState<boolean>(false);

  return {
    loginAsTypes,
    setLoginAsTypes,
    setLoggedAs,
    loggedAs,
  };
};
